import { useRouter } from "next/router";

import { OWN_ORIGIN } from "@/base/base.constants";

const useSignInUrl = () => {
  const { asPath } = useRouter() || { asPath: { text: "" } };
  const nextParam = OWN_ORIGIN + asPath;
  return `${OWN_ORIGIN}/signin?next=${nextParam}`;
};

export default useSignInUrl;
